import type { TFunction } from 'i18next';

export const userFields = {
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  EMAIL: 'email_address',
  ACCOUNT: 'account',
  ROLE: 'role',
} as const;

export const getUserLabels = (t: TFunction) => ({
  [userFields.FIRST_NAME]: t('First Name'),
  [userFields.LAST_NAME]: t('Last Name'),
  [userFields.EMAIL]: t('Email'),
  [userFields.ACCOUNT]: t('Organization'),
  [userFields.ROLE]: t('Role'),
});
